import { BlocksIconCube } from 'blocks-nextjs/blocks-web-components/components/icon/icons/cube';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCube = createComponent({ react: React, tagName: 'cat-icon-cube', elementClass: BlocksIconCube });
